import React, { Component } from 'react';
import './RandomSiteBase.css';

class App extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    console.log(this.props.headerFont)
    console.log(this.props.bodyFont)
  }

  componentDidUpdate() {
    var b = document.getElementsByClassName("btn-primary");
    for (var i = 0, il = b.length; i < il; i++) {

      b[i].style.backgroundColor = this.props.accentColor;
      b[i].style.borderColor = this.props.accentColor;
      b[i].style.color = this.props.backgroundColor;
    }
  }

  componentDidMount() {
    var b = document.getElementsByClassName("btn-primary");
    for (var i = 0, il = b.length; i < il; i++) {

      b[i].style.backgroundColor = this.props.accentColor;
      b[i].style.borderColor = this.props.accentColor;
      b[i].style.color = this.props.backgroundColor;
    }
  }

  render() {
    return (
      <div
        className="bodywrap"
        style={{
          backgroundColor: this.props.backgroundColor,
        }}
      >
        <link rel="stylesheet" type="text/css" href={'https://fonts.googleapis.com/css?family=' + this.props.headerFont} />
        <link rel="stylesheet" type="text/css" href={'https://fonts.googleapis.com/css?family=' + this.props.bodyFont} />
        <nav className="site-header sticky-top py-1">
          <div className="container d-flex flex-column flex-md-row justify-content-between">
            <a className="py-2" href="#">
              Header
                </a>
            <a className="py-2 d-none d-md-inline-block" href="#">Some</a>
            <a className="py-2 d-none d-md-inline-block" href="#">Important</a>
            <a className="py-2 d-none d-md-inline-block" href="#">Links</a>
            <a className="py-2 d-none d-md-inline-block" href="#">Here</a>
          </div>
        </nav>

        <div
          id="header-img"
          className="position-relative overflow-hidden m-md-3 text-center bg-light"
          style={{
            backgroundImage: 'url(' + this.props.imageUrl + ')'
          }}
        >
          <div className="overlay"></div>
          <div
            className="col-md-5 p-lg-5 mx-auto"

          >
            <h1 className="display-4 font-weight-normal" style={{ fontFamily: this.props.headerFont, marginTop: '10vh' }}>Your average marketing website</h1>
            <p className="lead font-weight-normal" style={{ fontFamily: this.props.bodyFont }}>Press space to generate new</p>
            <a className="btn btn-primary" href="#">Coming soon</a>
          </div>
        </div>

        <div className="container padded-container"
          style={{
            color: this.props.baseColor,
          }}>
          <div className="row text-center">
            <div className="col-lg-4">
              <img className="rounded-circle" src="data:image/gif;base64,R0lGODlhAQABAIAAAHd3dwAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==" alt="Generic placeholder image" width="140" height="140" />
              <h2 style={{ fontFamily: this.props.headerFont }}>Another headline</h2>
              <p style={{ fontFamily: this.props.bodyFont }}>Donec sed odio dui. Etiam porta sem malesuada magna mollis euismod. Nullam id dolor id nibh ultricies vehicula ut id elit. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Praesent commodo cursus magna.</p>
              <p><a className="btn btn-primary" href="#" role="button">View details &raquo;</a></p>
            </div>
            <div className="col-lg-4">
              <img className="rounded-circle" src="data:image/gif;base64,R0lGODlhAQABAIAAAHd3dwAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==" alt="Generic placeholder image" width="140" height="140" />
              <h2 style={{ fontFamily: this.props.headerFont }}>Another headline</h2>
              <p style={{ fontFamily: this.props.bodyFont }}>Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Cras mattis consectetur purus sit amet fermentum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh.</p>
              <p><a className="btn btn-primary" href="#" role="button">View details &raquo;</a></p>
            </div>
            <div className="col-lg-4">
              <img className="rounded-circle" src="data:image/gif;base64,R0lGODlhAQABAIAAAHd3dwAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==" alt="Generic placeholder image" width="140" height="140" />
              <h2 style={{ fontFamily: this.props.headerFont }}>Another headline</h2>
              <p style={{ fontFamily: this.props.bodyFont }}>Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.</p>
              <p><a className="btn btn-primary" href="#" role="button">View details &raquo;</a></p>
            </div>
          </div>
        </div>

        <hr />

        <div
          className="container padded-container"
          style={{
            color: this.props.baseColor,
          }}
        >
          <div className="row featurette">
            <div className="col-md-7">
              <h2 className="featurette-heading" style={{ fontFamily: this.props.headerFont }}>Yet another headline.</h2>
              <p className="lead" style={{ fontFamily: this.props.bodyFont }}>Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Praesent commodo cursus magna, vel scelerisque nisl consectetur. Fusce dapibus, tellus ac cursus commodo.</p>
            </div>
            <div className="col-md-5">
              <img className="featurette-image img-fluid mx-auto" src={this.props.imageUrl} alt="Generic placeholder image" />
            </div>
          </div>
        </div>

        <footer className="bg-dark">
          <div className="container padded-container">
            <div className="row">
              <div className="col pt-3 px-3 pt-md-5 px-md-5 text-center">
                <p style={{ fontFamily: this.props.bodyFont, color: 'white' }}>
                  Bacon ipsum dolor amet pork loin cow ham hock, salami turkey pork meatball drumstick pork
                  belly hamburger short ribs ham.
                </p>
              </div>
            </div>
          </div>
        </footer>


      </div >

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/RandomSiteBase.js